module.exports = __webpack_public_path__ + "img/PriceQuotations_FinishJobOrderCustomerReceive.af94aedc.svg";